import styled from 'styled-components';

const clsPrefix = 'ui-status-box';

export const statusBoxClasses = {
  wrapper: clsPrefix,
  icon: `${clsPrefix}-icon`,
  title: `${clsPrefix}-title`,
  description: `${clsPrefix}-description`,
} as const;

export const StatusBoxSC = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 32px;

  .${statusBoxClasses.icon} {
    margin: 32px 0;
  }

  .${statusBoxClasses.title} {
    text-align: center;
    ${({ theme }) => theme.mappedTypography.h3.default};
  }

  .${statusBoxClasses.description} {
    text-align: center;
    margin: 16px 0;
    color: ${({ theme }) => theme.color.tint.secondary};
    ${({ theme }) => theme.mappedTypography.body1.default};
  }
`;
